<template>
  <div>
    <div class="value_your_trade_graphic position-relative bg-white rounded-box shadow-sm p-3 mb-4  ai_new_design">
      <div class="iframe_box">
        <iframe :src="kbbDetails.uri" frameborder="0" title="IFrame Trade Valuation" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    responseData: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    kbbDetails: function () {
      return this.responseData;
    },
  },
};
</script>

<style lang="less" scoped>
.value_your_trade_graphic {

  .iframe_box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px 0 0 0;
    height: 400px;
  }

  iframe {
    height: 100%;
    display: block;
    margin: auto;
  }
}
</style>
